import products from 'redux/middleware/analytics/actions-to-track/products-and-components/grids/interstitials-products';
import { getFeatureFlags } from 'utils/feature-flags';
import navigation from './navigation';

export default state => {
  const { EoS_interstitialsAnalytics: eosInterstitialsAnalytics } = getFeatureFlags();
  if (eosInterstitialsAnalytics) return [products(state)];
  return [navigation(state), products(state)];
};
